import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ConfigureInformationService } from '../configure-information.service';
import { DropdownTypeEnum } from 'app/shared/enums/dropdowns.enum';
import { 
  CASE_TYPE_TABLE_CONFIG,
  CLASSIFICATION_TABLE_CONFIG,
  CUSTOMER_CENTER_APPS_COMPLEX_TABLE_CONFIG,
  CUSTOMER_CENTER_COMPLEX_TABLE_CONFIG,
  CUSTOMER_INFORMATION_COMPONENT_TABLE_CONFIG,
  DISTRIBUTED_MANUFACTURING_PC_TABLE_CONFIG,
  EQUIPMENT_STATUS_TABLE_CONFIG,
  ESCALATION_CATEGORY_TABLE_CONFIG,
  FAMILY_NAME_TABLE_CONFIG,
  FAMILY_VARIANT_TABLE_CONFIG,
  PROCESS_INFORMATION_COMPONENT_TABLE_CONFIG,
  PROCESS_TYPE_TABLE_CONFIG,
  PRODUCT_COMPANY_COMPLEX_TABLE_CONFIG,
  PRODUCT_INFORMATION_COMPONENT_TABLE_CONFIG,
  ROOT_CAUSE_SYSTEM_COMPONENT_COMPLEX_TABLE_CONFIG,
  ROOT_CAUSE_TABLE_CONFIG,
  STC_COMPLEX_TABLE_CONFIG,
  SUPPLIER_ENGAGED_TABLE_CONFIG,
} from '../configure-information-datatable/configure-information-datatable.config';
import { Tab } from 'app/shared/enums/profile.enum';
import { DiscardChangesService } from 'app/shared/services/discard-changes.service';

@Component({
  selector: 'app-configure-information-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './configure-information-sidebar.component.html',
  styleUrl: './configure-information-sidebar.component.scss'
})
export class ConfigureInformationSidebarComponent implements OnInit {
  @Input() sidebarConfigType: string = '';

  activeId: number = 1;

  newRow = {
    id: null,
    entry1: null,
    entry2: null,
    entry3: null,
    entry4: null,
    entry5: null,
    entry6: null,
  };

  userNewRow = {
    id: null,
    entry1: null,
    entry2: null,
    entry3: null,
    user1: null,
    user2: null,
    comments: null,
  };

  sidebarConfig: any = [];

  simpleSidebarConfig = [
    {
      activeClassId: 1,
      title: 'label.case_type',
      isSimple: true,
      type: DropdownTypeEnum.CASE_TYPE,
      columns: CASE_TYPE_TABLE_CONFIG,
      addNewRow: this.newRow
    },
    {
      activeClassId: 2,
      title: 'label.classifications',
      isSimple: true,
      type: DropdownTypeEnum.CLASSIFICATION,
      columns: CLASSIFICATION_TABLE_CONFIG,
      addNewRow: this.newRow
    },
    {
      activeClassId: 3,
      title: 'label.equipment_status',
      isSimple: true,
      type: DropdownTypeEnum.EQUIPMENT_STATUS,
      columns: EQUIPMENT_STATUS_TABLE_CONFIG,
      addNewRow: this.newRow
    },
    {
      activeClassId: 4,
      title: 'label.family_name',
      isSimple: true,
      type: DropdownTypeEnum.FAMILY_NAME,
      columns: FAMILY_NAME_TABLE_CONFIG,
      addNewRow: this.newRow
    },
    {
      activeClassId: 5,
      title: 'label.family_variant',
      isSimple: true,
      type: DropdownTypeEnum.FAMILY_VARIANT,
      columns: FAMILY_VARIANT_TABLE_CONFIG,
      addNewRow: this.newRow
    },
    {
      activeClassId: 6,
      title: 'label.process_type',
      isSimple: true,
      type: DropdownTypeEnum.PROCESS_TYPE,
      columns: PROCESS_TYPE_TABLE_CONFIG,
      addNewRow: this.newRow
    },
    {
      activeClassId: 7,
      title: 'label.supplier_engaged',
      isSimple: true,
      type: DropdownTypeEnum.SUPPLIER_ENGAGED,
      columns: SUPPLIER_ENGAGED_TABLE_CONFIG,
      addNewRow: this.newRow
    },
    {
      activeClassId: 8,
      title: 'label.escalation_category',
      isSimple: true,
      type: DropdownTypeEnum.ESCALATION_CATEGORY,
      columns: ESCALATION_CATEGORY_TABLE_CONFIG,
      addNewRow: this.newRow
    },
    {
      activeClassId: 9,
      title: 'label.rootCauseCodeText',
      isSimple: true,
      type: DropdownTypeEnum.ROOT_CAUSE,
      columns: ROOT_CAUSE_TABLE_CONFIG,
      addNewRow: this.newRow
    },
    {
      activeClassId: 10,
      title: 'case.fields.distributedManufacturingPc.label',
      isSimple: true,
      type: DropdownTypeEnum.DISTRIBUTED_MANUFACTURING_PC,
      columns: DISTRIBUTED_MANUFACTURING_PC_TABLE_CONFIG,
      addNewRow: this.newRow
    },
  ];

  complexSidebarConfig = [
    {
      activeClassId: 1,
      title: 'label.customer_information',
      isSimple: false,
      type: DropdownTypeEnum.CUSTOMER_INFORMATION,
      columns: CUSTOMER_INFORMATION_COMPONENT_TABLE_CONFIG,
      addNewRow: this.newRow,
      lastColumn: 'entry6',
      numberOfColumns: 6,
      skipValidation: ['entry4', 'entry5', 'entry6']
    },
    {
      activeClassId: 2,
      title: 'label.product_information',
      isSimple: false,
      type: DropdownTypeEnum.PRODUCT_INFORMATION,
      columns: PRODUCT_INFORMATION_COMPONENT_TABLE_CONFIG,
      addNewRow: this.newRow,
      lastColumn: 'entry5',
      numberOfColumns: 5
    },
    {
      activeClassId: 3,
      title: 'label.process_information',
      isSimple: false,
      type: DropdownTypeEnum.PROCESS_INFORMATION,
      columns: PROCESS_INFORMATION_COMPONENT_TABLE_CONFIG,
      addNewRow: this.newRow,
      lastColumn: 'entry3',
      numberOfColumns: 3
    },
    {
      activeClassId: 4,
      title: 'label.root_cause_information',
      isSimple: false,
      type: DropdownTypeEnum.ROOT_CAUSE_SYSTEM_COMPONENT_COMPLEX,
      columns: ROOT_CAUSE_SYSTEM_COMPONENT_COMPLEX_TABLE_CONFIG,
      addNewRow: this.newRow,
      lastColumn: 'entry4',
      numberOfColumns: 4
    },
    {
      activeClassId: 5,
      title: 'label.customer_center_apps',
      isSimple: false,
      type: DropdownTypeEnum.CUSTOMER_CENTER_APPS_COMPLEX,
      columns: CUSTOMER_CENTER_APPS_COMPLEX_TABLE_CONFIG,
      addNewRow: this.userNewRow,
      lastColumn: 'user2',
      numberOfColumns: 3,
      hasUsersSelect: true,
    },
    {
      activeClassId: 6,
      title: 'label.customer_center',
      isSimple: false,
      type: DropdownTypeEnum.CUSTOMER_CENTER_COMPLEX,
      columns: CUSTOMER_CENTER_COMPLEX_TABLE_CONFIG,
      addNewRow: this.userNewRow,
      lastColumn: 'user2',
      numberOfColumns: 4,
      hasUsersSelect: true,
      hasTwoEntries: true,
    },
    {
      activeClassId: 7,
      title: 'label.stc',
      isSimple: false,
      type: DropdownTypeEnum.STC_COMPLEX,
      columns: STC_COMPLEX_TABLE_CONFIG,
      addNewRow: this.userNewRow,
      lastColumn: 'comments',
      numberOfColumns: 4,
      hasUsersSelect: true,
    },
    {
      activeClassId: 8,
      title: 'label.product_company',
      isSimple: false,
      type: DropdownTypeEnum.PRODUCT_COMPANY_COMPLEX,
      columns: PRODUCT_COMPANY_COMPLEX_TABLE_CONFIG,
      addNewRow: this.userNewRow,
      lastColumn: 'user2',
      numberOfColumns: 5,
      hasUsersSelect: true,
      hasThreeEntries: true,
    },
  ];

  constructor(
    private configureInformationService: ConfigureInformationService,
    private discardChangesService: DiscardChangesService
  ) {}

  ngOnInit(): void {

    switch (this.sidebarConfigType) {
      case Tab.SimpleDropdowns:
        this.sidebarConfig = [];
        this.sidebarConfig = this.simpleSidebarConfig;
        break;
      case Tab.ComplexDropdowns:
        this.sidebarConfig = [];
        this.sidebarConfig = this.complexSidebarConfig;
        break;
    }

    setTimeout(() => {
      this.configureInformationService.sidebarItemDataEmiter.emit(this.sidebarConfig[0]);
    });
  }

  goToItem(item: any) {
    this.discardChangesService.canDeactivate().then(
      (result) => {
        if(result) {
          this.activeId = item?.activeClassId;
          this.configureInformationService.sidebarItemDataEmiter.emit(item);
        }
      }
    );
  }

}
